var React = require('react');

function TrianglePurchase1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M66.2114 65.5074L104.08 14.2447L126.978 111.142L66.2114 65.5074Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M5.59184 55.786L104.183 14.2588L66.3381 65.4394L5.59184 55.786Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M5.59766 55.79L66.3011 65.4367L126.984 111.144L5.59766 55.79Z","fill":"#5915C7","key":2})]);
}

TrianglePurchase1.defaultProps = {"width":"142","height":"112","viewBox":"0 0 142 112","fill":"none"};

module.exports = TrianglePurchase1;

TrianglePurchase1.default = TrianglePurchase1;
